import React, { useState } from 'react';
import { Button } from './ui/Button';
export function PartnerForm() {
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  return <section id="partner" className="py-24 bg-[#ecdfd2]/20 border-t border-[#ecdfd2]" data-id="element-106">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-107">
        <div className="text-center mb-12" data-id="element-108">
          <h2 className="text-3xl md:text-4xl font-bold text-[#3b2316] mb-4" data-id="element-109">
            Partner With Us
          </h2>
          <p className="text-xl text-[#5a3a28]/80" data-id="element-110">
            This work is only possible because of our community partners who
            serve as judges and sponsors. Please fill out the form below to join
            us.
          </p>
        </div>

        {status === 'success' ? <div className="bg-[#c06a2b]/10 p-8 rounded-lg text-center border border-[#c06a2b]/20" data-id="element-111">
            <h3 className="text-2xl font-bold text-[#c06a2b] mb-4" data-id="element-112">
              Thank you for your interest.
            </h3>
            <p className="text-[#5a3a28] mb-6" data-id="element-113">
              We have received your inquiry and will be in touch shortly to
              discuss how we can work together.
            </p>
            <Button variant="outline" onClick={() => setStatus('idle')} data-id="element-114">
              Send Another Message
            </Button>
          </div> : status === 'error' ? <div className="bg-red-50 p-8 rounded-lg text-center border border-red-200" data-id="element-115">
            <h3 className="text-2xl font-bold text-red-700 mb-4" data-id="element-116">
              Something went wrong
            </h3>
            <p className="text-[#5a3a28] mb-6" data-id="element-117">
              We couldn't send your message. Please try again or email us
              directly at{' '}
              <a href="mailto:info@goodfatherproject.org" className="text-[#c06a2b] hover:underline" data-id="element-118">
                info@goodfatherproject.org
              </a>
            </p>
            <Button variant="outline" onClick={() => setStatus('idle')} data-id="element-119">
              Try Again
            </Button>
          </div> : <form action="https://formsubmit.co/travishellstrom@gmail.com" method="POST" className="space-y-6 bg-white p-8 md:p-12 rounded-lg border border-[#ecdfd2] shadow-sm" data-id="element-120">
            {/* FormSubmit configuration */}
            <input type="hidden" name="_subject" value="New Partnership Inquiry - Good Father Project" data-id="element-121" />
            <input type="hidden" name="_captcha" value="false" data-id="element-122" />
            <input type="hidden" name="_template" value="table" data-id="element-123" />

            <div className="grid md:grid-cols-2 gap-6" data-id="element-124">
              <div className="space-y-2" data-id="element-125">
                <label htmlFor="orgName" className="block text-sm font-medium text-[#3b2316]" data-id="element-126">
                  Organization Name
                </label>
                <input type="text" id="orgName" name="Organization" required className="w-full px-4 py-3 bg-white border border-[#ecdfd2] rounded-lg focus:ring-2 focus:ring-[#c06a2b] focus:border-transparent outline-none transition-all" placeholder="Local organization" data-id="element-127" />
              </div>

              <div className="space-y-2" data-id="element-128">
                <label htmlFor="contactName" className="block text-sm font-medium text-[#3b2316]" data-id="element-129">
                  Contact Name
                </label>
                <input type="text" id="contactName" name="Name" required className="w-full px-4 py-3 bg-white border border-[#ecdfd2] rounded-lg focus:ring-2 focus:ring-[#c06a2b] focus:border-transparent outline-none transition-all" placeholder="Your full name" data-id="element-130" />
              </div>
            </div>

            <div className="space-y-2" data-id="element-131">
              <label htmlFor="email" className="block text-sm font-medium text-[#3b2316]" data-id="element-132">
                Email Address
              </label>
              <input type="email" id="email" name="Email" required className="w-full px-4 py-3 bg-white border border-[#ecdfd2] rounded-lg focus:ring-2 focus:ring-[#c06a2b] focus:border-transparent outline-none transition-all" placeholder="name@organization.org" data-id="element-133" />
            </div>

            <div className="space-y-2" data-id="element-134">
              <label htmlFor="message" className="block text-sm font-medium text-[#3b2316]" data-id="element-135">
                Message
              </label>
              <textarea id="message" name="Message" required rows={4} className="w-full px-4 py-3 bg-white border border-[#ecdfd2] rounded-lg focus:ring-2 focus:ring-[#c06a2b] focus:border-transparent outline-none transition-all resize-none" placeholder="Tell us how you'd like to partner..." data-id="element-136" />
            </div>

            <div className="pt-4" data-id="element-137">
              <Button type="submit" className="w-full md:w-auto" data-id="element-138">
                Send
              </Button>
            </div>
          </form>}
      </div>
    </section>;
}